import { get } from './helpers'
import { PromoCode } from 'types'

export const getPromoCodes = async (): Promise<PromoCode[]> => {
  const promoCodes = await get<PromoCode[]>(`/promoCodes`)

  return promoCodes
}
